<template>
  <div class="form-wrapper">
    <h2>Add Harvest</h2>
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label>Unit</label>
        <select v-model="harvest.unit_id">
          <option v-for="unit in units" :key="unit.id" :value="unit.id">{{ unit.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Quantity</label>
        <input v-model="harvest.quantity" type="number" placeholder="Quantity" required />
      </div>
      <div class="form-group">
        <label>Date</label>
        <input v-model="harvest.date" type="date" required />
      </div>
      <button class="btn btn-gradient" type="submit">
        <span v-if="loading">Saving...</span>
        <span v-else>Save Harvest</span>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'AddHarvestComponent',
  data() {
    return {
      harvest: { unit_id: '', quantity: 0, date: '' },
      loading: false,
      units: []
    };
  },
  methods: {
    fetchUnits() { this.units = this.$store.state.units.items || []; },
    submitForm() {
      this.loading = true;
      this.$store.dispatch('harvests/addHarvest', this.harvest)
        .then(() => this.$router.push({ name: 'Harvests' }))
        .finally(() => this.loading = false);
    }
  },
  mounted() { this.fetchUnits(); }
};
</script>
